export const translations = {
	en: {
		categories: 'Categories',
		useOfTheDatabase: 'Copyright',
		contact: 'Contact',
		navigateBack: 'Navigate back',
		downloadMedia: 'Download Media',
		readTexts: 'Read texts',
		searchMedia: 'Search in media',
		searchTitlesAndTags: 'Search titles, tags',
		downloadAll: 'Download all',
		small: 'Small',
		medium: 'Medium',
		large: 'Large',
		extraLarge: 'Extra large',
		original: 'Original',
		copyText: 'Copy text',
		theTextIsCopied: 'The text is copied',
		saveTexts: 'Save texts',
		noSearchResults: 'Your search did not match any results',
		searchIntroText: 'Search for content in the Content Pool',
		search: 'Search...',
		showOnly: 'Show only',
		months: 'Months',
		places: 'Places',
		price: 'Price',
		close: 'Close',
		moreInfo: 'More info',
		cookies: 'Cookies',
		cookieText: 'We use cookies to collect usage data, to improve our website.',
		cookieLink: '/en/cookies',
		cookieLinkText: 'Read our cookie- og privacypolicy',
		cookieButtonText: 'I accept',
		cookieButtonDeny: 'No thanks',
		cookieHeading: 'We use cookies for statistics',
		acceptConditions: 'I accept the terms of use',
		accessibilityDeclarationLink: 'Accessibility',
	},
	da: {
		categories: 'Kategorier',
		useOfTheDatabase: 'Ophavsret',
		contact: 'Kontakt',
		navigateBack: 'Tilbage',
		downloadMedia: 'Download medier',
		readTexts: 'Læs tekster',
		searchMedia: 'Søg i medier',
		searchTitlesAndTags: 'Søg titler, tags',
		downloadAll: 'Download alt',
		small: 'Lille',
		medium: 'Medium',
		large: 'Stor',
		extraLarge: 'Ekstra stor',
		original: 'Original',
		copyText: 'Kopier tekst',
		theTextIsCopied: 'Teksten er kopieret',
		saveTexts: 'Gem tekster',
		noSearchResults: 'Din søgning gav desværre ikke nogen resultater',
		searchIntroText: 'Søg efter indhold i Content Poolen',
		search: 'Søg...',
		showOnly: 'Vis kun',
		months: 'Måneder',
		places: 'Steder',
		price: 'Pris',
		close: 'Luk',
		moreInfo: 'Mere info',
		cookies: 'Cookies',
		cookieText: 'Vi bruger cookies til at samle statistik, for at forbedre vores website.',
		cookieLink: '/da/cookies',
		cookieLinkText: 'Læs vores cookie- og privatlivspolitik',
		cookieButtonText: 'Jeg accepterer',
		cookieButtonDeny: 'Nej tak',
		cookieHeading: 'Vi bruger cookies til statistik',
		acceptConditions: 'Jeg accepterer betingelserne',
		accessibilityDeclarationLink: 'Tilgængelighedserklæring',
	},
	de: {
		categories: 'Kategorien',
		useOfTheDatabase: 'Urheberrecht',
		contact: 'Kontakt',
		navigateBack: 'Zurück',
		downloadMedia: 'Medien herunterladen',
		readTexts: 'Texte lesen',
		searchMedia: 'Medien suchen',
		searchTitlesAndTags: 'Titel, Tags suchen',
		downloadAll: 'Alles herunterladen',
		small: 'Klein',
		medium: 'Mittel',
		large: 'Groß',
		extraLarge: 'Extra groß',
		original: 'Original',
		copyText: 'Text kopieren',
		theTextIsCopied: 'Der Text ist kopiert',
		saveTexts: 'Texte speichern',
		noSearchResults: 'Ihre Suche ergab keine Ergebnisse',
		searchIntroText: 'Suche nach Inhalten im Content Pool',
		search: 'Suchen...',
		showOnly: 'Nur anzeigen',
		months: 'Monate',
		places: 'Standorte',
		price: 'Preis',
		close: 'Schließen',
		moreInfo: 'Weitere Info',
		cookies: 'Cookies',
		cookieText: 'Wir verwenden Cookies, um Statistiken zu sammeln, um unsere Website zu verbessern.',
		cookieLink: '/de/cookies',
		cookieLinkText: 'Lesen unsere cookie- og datenschutzbestimmungen',
		cookieButtonText: 'Ich akzeptiere',
		cookieButtonDeny: 'Nein danke',
		cookieHeading: 'Wir verwenden Cookies für Statistiken',
		acceptConditions: 'Ich akzeptiere',
		accessibilityDeclarationLink: 'Zugänglichkeit',
	},
};



// WEBPACK FOOTER //
// ./assets/_js/translation.js